import { useContext, useState } from "react";
import { AuthStateContext } from "../../contexts/AuthStateContext";
import { useNavigate } from "react-router-dom";
import GptAiModal from "../gpt-ai-modal/gpt-ai-modal";

interface GptAiButtonProps {
  gender: string;
  birthDayType: string;
  yearMonthDay: string;
  hourMin: string;
  unknownTime: boolean;
}
export default function GptAiButton({
  gender,
  birthDayType,
  yearMonthDay,
  hourMin,
  unknownTime,
}: GptAiButtonProps) {
  const { authState } = useContext(AuthStateContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const onClick = () => {
    if (!authState) {
      navigate("/app/login");
      return;
    }
    console.log("gender", gender);
    console.log("birthDayType", birthDayType);
    console.log("yearMonthDay", yearMonthDay);
    console.log("hourMin", hourMin);
    console.log("unknownTime", unknownTime);
    setIsModalOpen(true);
  };
  return (
    <>
      <button
        className="mb-2 w-full h-[54px] bg-white rounded-xl border-2 border-transparent bg-gradient-to-r from-blue-300 via-pink-300 to-purple-400 bg-clip-border relative overflow-hidden flex items-center justify-center px-4 transition-all duration-300"
        style={{
          background:
            "linear-gradient(white, white) padding-box, linear-gradient(90deg, #93c5fd, #f9a8d4, #c084fc) border-box",
          border: "2px solid transparent",
          WebkitTapHighlightColor: "transparent",
        }}
        onClick={onClick}
      >
        {/* 반짝이는 아이콘들 */}
        {/* margin-bottom: 2px; */}
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginBottom: "10px" }}
        >
          <path
            opacity="0.8"
            d="M12 0L13.4425 4.5575L18 6L13.4425 7.4425L12 12L10.5575 7.4425L6 6L10.5575 4.5575L12 0Z"
            fill="url(#paint0_linear_0_1)"
          />
          <path
            opacity="0.8"
            d="M4 8L4.96167 11.0383L8 12L4.96167 12.9617L4 16L3.03833 12.9617L0 12L3.03833 11.0383L4 8Z"
            fill="url(#paint1_linear_0_1)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="18"
              y1="-1.21395"
              x2="5.16711"
              y2="-0.132614"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00CEFF" />
              <stop offset="0.5" stop-color="#A84EFF" />
              <stop offset="1" stop-color="#FF0087" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_0_1"
              x1="8"
              y1="7.1907"
              x2="-0.555257"
              y2="7.91159"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00CEFF" />
              <stop offset="0.5" stop-color="#A84EFF" />
              <stop offset="1" stop-color="#FF0087" />
            </linearGradient>
          </defs>
        </svg>

        {/* 텍스트 */}
        <span className="text-black font-extrabold">
          {authState
            ? "AI 사주 무료 해석(3회 가능)"
            : "AI 사주 무료 해석(회원 전용)"}
        </span>
      </button>
      {isModalOpen && (
        <GptAiModal
          gender={gender}
          birthDayType={birthDayType}
          yearMonthDay={yearMonthDay}
          hourMin={hourMin}
          unknownTime={unknownTime}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
}

/**
 * + 안드로이드 APP only
+ 메인페이지만 적용(궁합x)
+ 하루 3회
+ 하루 3회 소진 시 모달표시
+ 사주보기 버튼 클릭 후 적용가능
+ 로그인 회원만 가능
+ 비회원은 로그인 페이지 이동
 */
